import { useNavigate } from "react-router-dom";
import { PatientsTab } from "../psychologist/tabs";

export const PatientsPage = () => {
  const navigate = useNavigate();

  return <PatientsTab onSchedule={(processId: string) => navigate(`/calendar?process=${encodeURIComponent(processId)}`)} />;
};
